import React from "react";

const Index = () => {
  // const randomColor = () => {
  //   const colors = ["#a0f4e7", "#e7f7f3", "#f96765", "#f89f92", "#e9d8e4"];
  //   return colors[Math.floor(Math.random() * colors.length)];
  // };

  return (
    <div className="container mx-auto p-2">
      <h1 className="text-3xl md:text-4xl mt-2 mb-5">Dashboard</h1>
      <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-4">
        <div className="w-full h-52 bg-[#a0f4e7] px-4 py-3 rounded-md flex flex-col justify-between items-start">
          <h2 className="text-xl">Total Stock Available Products</h2>
          <h3 className="text-7xl font-semibold">234</h3>
          <div className="self-end">
            <select className="bg-transparent outline-none border-0">
              <option value="null">See List</option>
              <option value="product-1">Product 1</option>
              <option value="product-2">Product 2</option>
              <option value="product-3">Product 3</option>
            </select>
          </div>
        </div>
        <div className="w-full h-52 bg-[#e9d8e4] p-4 rounded-md flex flex-col justify-between items-start">
          <h2 className="text-xl">Total Category</h2>
          <h3 className="text-7xl font-semibold">12</h3>
          <div className="self-end">
            <select className="bg-transparent outline-none border-0">
              <option value="null">See List</option>
              <option value="product-1">Product 1</option>
              <option value="product-2">Product 2</option>
              <option value="product-3">Product 3</option>
            </select>
          </div>
        </div>
        <div className="w-full h-52 bg-[#e7f7f3] p-4 rounded-md flex flex-col justify-between items-start">
          <h2 className="text-xl">Total Suppliers</h2>
          <h3 className="text-7xl font-semibold">5</h3>
          <div className="self-end">
            <select className="bg-transparent outline-none border-0">
              <option value="null">See List</option>
              <option value="product-1">Product 1</option>
              <option value="product-2">Product 2</option>
              <option value="product-3">Product 3</option>
            </select>
          </div>
        </div>
        <div className="w-full h-52 bg-[#f89f92] p-4 rounded-md flex flex-col justify-between items-start">
          <h2 className="text-xl">Total Sales</h2>
          <h3 className="text-7xl font-semibold">55</h3>
          <div className="self-end">
            <select className="bg-transparent outline-none border-0">
              <option value="null">See List</option>
              <option value="product-1">Product 1</option>
              <option value="product-2">Product 2</option>
              <option value="product-3">Product 3</option>
            </select>
          </div>
        </div>
        <div className="w-full h-52 bg-[#a0f4e7] p-4 rounded-md flex flex-col justify-between items-start">
          <h2 className="text-xl">Total Sales Profit</h2>
          <h3 className="text-7xl font-semibold">
            533433<span className="text-xl">tk</span>
          </h3>
          <div className="self-end">
            <select className="bg-transparent outline-none border-0 hidden">
              <option value="null">See List</option>
              <option value="product-1">Product 1</option>
              <option value="product-2">Product 2</option>
              <option value="product-3">Product 3</option>
            </select>
          </div>
        </div>
        <div className="w-full h-52 bg-[#e9d8e4] p-4 rounded-md flex flex-col justify-between items-start">
          <h2 className="text-xl">Monthly Average Profit</h2>
          <h3 className="text-7xl font-semibold">
            32322<span className="text-xl">tk</span>
          </h3>
          <div className="self-end">
            <select className="bg-transparent outline-none hidden border-0">
              <option value="null">See List</option>
              <option value="product-1">Product 1</option>
              <option value="product-2">Product 2</option>
              <option value="product-3">Product 3</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
